import(/* webpackMode: "eager" */ "/var/www/vhosts/dailyneedsworld.com/httpdocs/src/app/contact/page.tsx");
